import { render, staticRenderFns } from "./investmentExperience.vue?vue&type=template&id=8ead8652&scoped=true"
import script from "./investmentExperience.vue?vue&type=script&lang=js"
export * from "./investmentExperience.vue?vue&type=script&lang=js"
import style0 from "./investmentExperience.vue?vue&type=style&index=0&id=8ead8652&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ead8652",
  null
  
)

export default component.exports